// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'tribox';

export const Component = () => (
  <>
    <path d='M.958 8.855h6.897v6.897H.958V8.855Zm7.854 7.854V7.897H0v8.812h8.813Zm7.854-14.703h6.897v6.849h-6.897V2.006Zm7.855 7.854V1H15.71v8.86h8.812Zm-7.855 5.892h6.897V22.6h-6.897v-6.848Zm7.855 7.853v-8.86H15.71v8.86h8.812Z' />
    <path d='m8.813 12.495-.67-.67 7.566-7.568.67.67-7.567 7.568Z' />
    <path d='M15.709 20.35 8.14 12.781l.67-.67 7.568 7.567-.67.67Z' />
  </>
);

export const viewBox = '0 0 25 25';
